import { useHttp } from "../http/useHttp";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";

type MinerManagementVisibilityOperation =
  paths["/dashboard/synota/contracts/{contract_shared_uuid}/miner-management-visibility"]["post"];
export type UseContractMinerManagementVisibilityInput =
  MinerManagementVisibilityOperation["parameters"]["path"] &
    MinerManagementVisibilityOperation["requestBody"]["content"]["application/json"];

export const useContractMinerManagementVisibility = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMfaMutation<
    void,
    UseContractMinerManagementVisibilityInput
  >({
    mutationKey: ["set-contract-miner-management-visibility"],
    mutationFn: ({ contract_shared_uuid, ...input }) =>
      client.post(`/synota/contracts/${contract_shared_uuid}/miner-management-visibility`, input),
  });

  useDefaultError(error, "Failed to save miner management visibility");

  return { setVisibility: mutate, isPending, status, data, error };
};

export type UseContractMinerManagementVisibilityReturn = ReturnType<
  typeof useContractMinerManagementVisibility
>;
